//src/pages/VisualBriefAddMaster.jsx (VisualBriefMaster Add/Update/Delete)
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone } from '@fortawesome/free-solid-svg-icons';
import 'react-datepicker/dist/react-datepicker.css';
import '../../styles/Concerns.css';
import '../../styles/Alert.css';
import VBUploader from './VBUploader';

const VisualBriefAddMaster = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const { vbMasterId } = useParams();
  const [userId, setUserId] = useState(authState.user._id);
  const mode = vbMasterId === undefined ? "add" : "update";
  const [vbMaster, setVbMaster] = useState(null);

  // console.log("Mode "+mode+" vbMasterId "+vbMasterId);

  const [formData, setFormData] = useState({
    userId: userId,
    title: "",
    desc: "",
    noOfSlides: 3,
    hasCoverImage: false,
    coverImageData: "",
    isActive: true,
    isDeleted: false,
    isPrepared: false,
    purpose: '',
    dateCreated: new Date(),
    createdBy: userId,
    isPresenting: false,
    // shared: [],
    // presented: [],
    canDownload: false,
    // downloads:null,
    // accessed: null,
    isPublic: false,
    forIndividual: false,
    // individualList: [],
    forGroup: false,
    // groupList: [],
    bookId: null,
    bookTitle: '',
  });
  const [formErrors, setFormErrors] = useState({});
  const [showMicrophoneAlert, setShowMicrophoneAlert] = useState(false);
  const [showAISupportAlert, setShowAISupportAlert] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [countFormErrors, setCountFormErrors] = useState(0);

  useEffect(() => {
    document.title = mode === "add" ? "Add" : "Update";
  }, [mode]);


  useEffect(() => {
    if (mode === "update") {
      const config = { 
        url: "/vbmaster/getforupdate", 
        method: "post", 
        headers: { Authorization: authState.token },
        data: {vbMasterId: vbMasterId}
      };

      fetchData(config, { showSuccessToast: false }).then((data) => {
        setVbMaster(data.vbmaster);
        setFormData({
          fileName: data.vbmaster._id,
          userId: data.vbmaster.userId,
          title: data.vbmaster.title,
          date: new Date(),
          desc: data.vbmaster.desc,
          noOfSlides: data.vbmaster.noOfSlides,
          hasCoverImage: data.vbmaster.hasCoverImage,
          coverImageData: data.vbmaster.coverImageData,
          isPrepared: data.vbmaster.isPrepared,
          isActive: data.vbmaster.isActive,
          isDeleted: data.vbmaster.isDeleted,
          purpose: data.vbmaster.purpose,
          isLocked: data.vbmaster.isLocked,
          dateCreated: data.vbmaster.dateCreated,
          isPresenting: data.vbmaster.isPresenting,
          createdBy: data.vbmaster.createdBy,
          // shared: data.vbmaster.shared,
          // presented: data.vbmaster.presented,
          canDownload: data.vbmaster.canDownload,
          // downloads:data.vbmaster.downloads,
          // accessed: data.vbmaster.accessed,
          isPublic: data.vbmaster.isPublic,
          forIndividual: data.vbmaster.forIndividual,
          // individualList: data.vbmaster.individualList,
          forGroup: data.vbmaster.forGroup,
          // groupList: data.vbmaster.groupList,
          bookId: data.vbmaster.bookId,
          bookTitle: data.vbmaster.bookTitle,
        });
      });
    }
  }, [mode, authState, vbMasterId, fetchData]);

  const handleChange = (e) => {
    setFormData({
      ...formData, [e.target.name]: e.target.value
    });
  };

  const [isError, setIsError] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = e => {
    if (e) e.preventDefault();
    const error = validateForm(formData);
    // console.log("error : ",error," no. of error",Object.keys(error).length);
    setFormErrors(error);
    setCountFormErrors(Object.keys(error).length);
    // console.log("setFormError : ",setFormErrors);

    if (Object.keys(error).length > 0) {
      setFormErrors(
        Object.keys(error).reduce((total, key) => {
          total[key] = error[key];
          return total;
        }, {})
      );
      return;
    }

    if (mode === "add") {
      const config = 
      { 
        url: "/vbmaster/add", 
        method: "post", 
        data: formData, 
        headers: { Authorization: authState.token } 
    };
    fetchData(config)
      .then(() => {
        navigate('/visualbrief-myvb');
      })
      .catch(error => {
        console.error("Error creating VisualBrief:", error);
        setIsError(true);
        setError("Error Creating Your Visual Brief Presentation Master")
      });
    }
    else {
      const config = { 
        url: `/vbmaster/${vbMasterId}`, 
        method: "put", 
        data: formData, 
        headers: { Authorization: authState.token } 
      };
      fetchData(config).then(() => {
        navigate('/visualbrief-myvb');
      });
    }
  }

  const validateForm = formData => {
    const errors = {};
    if (!formData.purpose) {
      errors.purpose = "Purpose is required";
    } 
    if (!formData.title) {
      errors.title = "Title is required";
    } else if (formData.title.length > 100) {
      errors.title = "Title cannot exceed 100 characters";
    }
    if (!formData.desc) {
      errors.desc = "Description is required";
    } else if (formData.desc.length > 1000) {
      errors.desc = "Description cannot exceed 1000 characters";
    }
    if (!formData.noOfSlides) {
      errors.noOfSlides = "Number of Slides is required";
    } else if (formData.noOfSlides < 3 || formData.noOfSlides > 25) {
      errors.noOfSlides = "Slides must be between 3 and 25";
    }
    return errors;
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-xs sm:text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )

  const handleMicrophoneClick = () => {
    setShowMicrophoneAlert(true);
  };

  const handleAISupportClick = () => {
    setShowAISupportAlert(true);
  };

  const handleCloseAlert = (alertType) => {
    if (alertType === 'microphone') {
      setShowMicrophoneAlert(false);
    } else if (alertType === 'aiSupport') {
      setShowAISupportAlert(false);
    }
  };

  
  


  return (
    <div className="py-2 bg-black min-h-screen">
      <header className="mb-2 border border-teal-500 bg-black px-4 sm:px-6">
          <h1 className="text-lg lg:text-2xl font-bold text-teal-300 py-2 text-start">VisualBrief Presentations</h1>
      </header>
      <div className="min-h-full py-4 px-4 sm:px-6 bg-black rounded-lg">
        <h2 className='text-lg lg:text-xl font-bold text-white text-center mb-2'>VisualBrief - Deck Master</h2>
        {loading ? (
            <Loader />
        ) : (
          <div className='text-sm space-y-6'>
            <div className='flex justify-center'>
              <h2 className="text-m lg:text-lg text-yellow-200">{mode === "add" ? "Add New Deck Master" : "Edit Deck Master"}</h2>
            </div>
            <form onSubmit={handleSubmit} className="border-container space-y-4 sm:space-y-6">
              <div className="space-y-4">
                <div>
                  <label htmlFor="purpose" className="block text-sm font-medium text-white mb-1">Select Purpose*:</label>
                  <select
                    name="purpose"
                    id="purpose"
                    value={formData.purpose}
                    onChange={handleChange}
                    className="w-full h-10 border border-gray-300 rounded-md px-3 py-2 text-black focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                  >
                    <option value="">---- Select Presentation Purpose ----</option>

                    <optgroup label="Albums & Portfolios">
                      <option value="Album with Description Deck">Album with Description Deck</option>
                      <option value="Food Catalogue">Food Catalogue</option>
                      <option value="Food Portfolio">Food Portfolio</option>
                      <option value="Portfolio Presentation">Portfolio Presentation</option>
                    </optgroup>

                    <optgroup label="Business & Corporate">
                      <option value="Business Presentation">Business Presentation</option>
                      <option value="Corporate Presentation">Corporate Presentation</option>
                      <option value="Pitch Deck">Pitch Deck</option>
                      <option value="Process Infographics Presentation">Process Infographics Presentation</option>
                      <option value="Product Catalogue">Product Catalogue</option>
                      <option value="MR Catalogue">MR Catalogue</option>
                    </optgroup>

                    <optgroup label="Education & Research">
                      <option value="Present Subject Outline">Present Subject Outline</option>
                      <option value="Present Topic Outline">Present Topic Outline</option>
                      <option value="Research Presentation">Research Presentation</option>
                      <option value="Self Study">Self Study</option>
                      <option value="Student Presentation">Student Presentation</option>
                      <option value="Teacher Presentation">Teacher Presentation</option>
                      <option value="Training Slides">Training Slides</option>
                    </optgroup>

                    <optgroup label="Events & Invitations">
                      <option value="Invitation Deck - Birthday">Invitation Deck - Birthday</option>
                      <option value="Invitation Deck - Event">Invitation Deck - Event</option>
                      <option value="Invitation Deck - Marriage">Invitation Deck - Marriage</option>
                      <option value="Marriag Moments Showcase">Marriage Moments Showcase</option> 
                      <option value="Past Birthday Moments Showcase">Past Birthday Moments Showcase</option>
                      <option value="Past Event Showcase">Past Event Showcase</option>
                      <option value="Past Festive Show">Past Festive Showcase</option> 
                      <option value="Upcoming Election Campaign Manifesto">Upcoming Election Campaign Manifesto</option>
                      <option value="Upcoming Event Blueprint">Upcoming Event Blueprint</option>
                      <option value="Upcoming Festive Blueprint">Upcoming Festive Blueprint</option>

                    </optgroup>

                    <optgroup label="Government & Investigation">
                      <option value="Government Presentation">Government Presentation</option>
                      <option value="Investigation Presentation">Investigation Presentation</option>
                      <option value="Job Description Presentation">Job Description Presentation</option>
                      <option value="RCA Presentation">RCA Presentation</option>
                      <option value="Scout Analysis">Scout Analysis</option>
                    </optgroup>

                    <optgroup label="Marketing & Promotions">
                      <option value="Movie Promotions">Movie Promotions</option>
                      <option value="Show Promotions">Show Promotions</option>
                      <option value="Webseries Promotions">Webseries Promotions</option>
                    </optgroup>

                    <optgroup label="Personal & Miscellaneous">
                      <option value="Resume Display">Resume Display</option>
                      <option value="Tell About Anything">Tell About Anything</option>
                      <option value="Tell About Yourself">Tell About Yourself</option>
                      <option value="Tips Deck">Tips Deck</option>
                      <option value="Demo Anything">Demo Anything</option>
                      <option value="Others">Others</option>
                    </optgroup>

                    <optgroup label="Property & Vehicles">
                      <option value="Property Video Deck">Property Video Deck</option>
                      <option value="Vehicle Video Deck">Vehicle Video Deck</option>
                    </optgroup>
                  </select>
                  {fieldError("purpose")}
                </div>
                <div>
                  <label htmlFor="title" className="block text-sm font-medium text-white mb-1">Title*:</label>
                  <input 
                    type="text" 
                    name="title" 
                    id="title" 
                    value={formData.title} 
                    placeholder="Enter the title..."
                    onChange={handleChange} 
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-black focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500" 
                  />
                  {fieldError("title")}
                </div>
                <div>
                  <label htmlFor="desc" className="block text-sm font-medium text-white mb-1">Description*:</label>
                  <textarea
                    name="desc"
                    id="desc"
                    value={formData.desc}
                    placeholder="Write Description"
                    onChange={handleChange} 
                    className='w-full text-black bg-slate-200 border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500'
                    rows={6}
                  />
                  {fieldError("desc")}
                </div>
                <div>
                  <label htmlFor="noOfSlides" className="block text-sm font-medium text-white mb-1">#Slides*:</label>
                  <input 
                    type="number" 
                    name="noOfSlides" 
                    id="noOfSlides" 
                    value={formData.noOfSlides} 
                    onChange={handleChange} 
                    className="w-full sm:w-20 border border-gray-300 rounded-md px-3 py-2 text-black focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500" 
                  />
                  {fieldError("noOfSlides")}
                </div>
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="hasCoverImage"
                    checked={formData.hasCoverImage}
                    onChange={(e) => setFormData({ ...formData, hasCoverImage: e.target.checked })}
                    className="h-4 w-4 text-teal-600 focus:ring-teal-500 border-gray-300 rounded mr-2"
                  />
                  <label htmlFor="hasCoverImage" className="text-sm text-white select-none">Has Cover Image?</label>
                </div>
                {formData.hasCoverImage && mode==="update" && (
                  <div className="pt-2">
                    <VBUploader param1="Cover Image" param2={formData.fileName} />
                  </div>
                )}
                <div className="space-y-3 pt-2">
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      id="isPrepared"
                      checked={formData.isPrepared}
                      onChange={(e) => setFormData({ ...formData, isPrepared: e.target.checked })}
                      className="h-4 w-4 text-teal-600 focus:ring-teal-500 border-gray-300 rounded mr-2"
                    />
                    <label htmlFor="isPrepared" className="text-sm text-white select-none">Is Prepared for Show?</label>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      id="isPublic"
                      checked={formData.isPublic}
                      onChange={(e) => setFormData({ ...formData, isPublic: e.target.checked })}
                      className="h-4 w-4 text-teal-600 focus:ring-teal-500 border-gray-300 rounded mr-2"
                    />
                    <label htmlFor="isPublic" className="text-sm text-white select-none">Is Public?</label>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      id="isActive"
                      checked={formData.isActive}
                      onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                      className="h-4 w-4 text-teal-600 focus:ring-teal-500 border-gray-300 rounded mr-2"
                    />
                    <label htmlFor="isActive" className="text-sm text-white select-none">Is Active</label>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      id="isPresenting"
                      checked={formData.isPresenting}
                      onChange={(e) => setFormData({ ...formData, isPresenting: e.target.checked })}
                      className="h-4 w-4 text-teal-600 focus:ring-teal-500 border-gray-300 rounded mr-2"
                    />
                    <label htmlFor="isPresenting" className="text-sm text-white select-none">Presenting Now?</label>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      id="canDownload"
                      checked={formData.canDownload}
                      onChange={(e) => setFormData({ ...formData, canDownload: e.target.checked })}
                      className="h-4 w-4 text-teal-600 focus:ring-teal-500 border-gray-300 rounded mr-2"
                    />
                    <label htmlFor="canDownload" className="text-sm text-white select-none">Can Download?</label>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      id="forIndividual"
                      checked={formData.forIndividual}
                      onChange={(e) => setFormData({ ...formData, forIndividual: e.target.checked })}
                      className="h-4 w-4 text-teal-600 focus:ring-teal-500 border-gray-300 rounded mr-2"
                    />
                    <label htmlFor="forIndividual" className="text-sm text-white select-none">Presentation Is For Specific People?</label>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      id="forGroup"
                      checked={formData.forGroup}
                      onChange={(e) => setFormData({ ...formData, forGroup: e.target.checked })}
                      className="h-4 w-4 text-teal-600 focus:ring-teal-500 border-gray-300 rounded mr-2"
                    />
                    <label htmlFor="forGroup" className="text-sm text-white select-none">Presentation Is For Specific Groups?</label>
                  </div>
                </div>
                <div>
                  <label htmlFor="bookTitle" className="block text-sm font-medium text-white mb-1">Book Title:</label>
                  <input 
                    type="text" 
                    name="bookTitle" 
                    id="bookTitle" 
                    value={formData.bookTitle} 
                    placeholder="Enter the title..."
                    onChange={handleChange} 
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-black focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500" 
                  />
                  {fieldError("bookTitle")}
                </div>
              </div>
              <div className="space-y-4 pt-4">
                {Object.keys(formErrors).length > 0 && (
                  <div className="form-errors bg-red-900/20 border border-red-500 text-red-300 p-3 rounded-md">
                    {Object.keys(formErrors).map((key) => (
                      <div className="flex items-center text-sm" key={key}>
                        <i className='mr-2 fa-solid fa-circle-exclamation'></i>
                        {formErrors[key]}
                      </div>
                    ))}
                  </div>
                )}
                {isError && (
                  <div className='bg-red-900/20 border border-red-500 text-red-300 p-3 rounded-md text-sm'>
                    {error}
                  </div>
                )}
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <button 
                    type="submit"
                    className='bg-primary text-white px-6 py-3 font-medium hover:bg-primary-dark rounded-md transition-colors w-full sm:w-auto' 
                  >
                    {mode === "add" ? "Add New" : "Update"}
                  </button>
                  <button 
                    type="button"
                    className='bg-red-500 text-white px-6 py-3 font-medium hover:bg-red-600 rounded-md transition-colors w-full sm:w-auto' 
                    onClick={() => navigate("/visualbrief-myvb")}>
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default VisualBriefAddMaster